import React from 'react'
import { Box, CardActions } from '@mui/material'
import { NOOP, getStyle } from '@fedsim/helpers'

import { Actions } from '../../actions'
import { GenericCard } from '../cards'
import { useCardStyles } from './generic.card.style'

export function GenericCards({
  itemStyle = getStyle,
  actions = [],
  collection = [],
  onClick = NOOP,
  PresentationItem = GenericCard
}) {
  const styles = useCardStyles()
  if (collection.length === 0) {
    return null
  }
  return (
    <Box className={styles.container}>
      <ul className={styles.list}>
        {collection.map((item, index) => {
          const key = item?.id ? item.id : index
          const payload = item?.id ? item.id : item
          const singleClick = () => onClick(payload, index)
          const style = item ? itemStyle(item) : {}

          return (
            <li
              key={key}
              className={styles.card}
              style={style}
              onClick={singleClick}
              tabIndex={0}
            >
              <PresentationItem {...item} style={{ flexGrow: 1 }} />
              {actions.length > 0 && (
                <CardActions>
                  <Actions
                    actions={actions}
                    payload={item}
                    orientation='horizontal'
                  />
                </CardActions>
              )}
            </li>
          )
        })}
      </ul>
    </Box>
  )
}
